// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"bbc87bc6","239":"f0cd0a49","344":"bcc19d0c","453":"6d8fcdd2","457":"0cfbec46","492":"ddda5850","551":"baeb237a","587":"65018544","596":"06db4147","640":"48f4f7f6","695":"421764e7","727":"9ae43776","771":"8ec58f3e","784":"2ca1d2fa","851":"8b8ff016","977":"1193e685"}[chunkId] + ".chunk.js";
};